import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=1d9e8383&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"
import style0 from "./OrdersView.vue?vue&type=style&index=0&id=1d9e8383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e8383",
  null
  
)

export default component.exports